<template>
<div>
  <div>
    <!-- <v-overlay v-if="loading" :value="loading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay> -->
    <!-- <div v-else> -->
    <div>
      <v-row>
        <!-- <v-col cols="12" sm="10">
          <p class="mytitle primary--text">داشبورد(نمایش ۱۲ تراکنش آخر + اونس نقره)</p>
        </v-col> -->
        <v-col cols="12" sm="10">
          <v-row dense>
            <v-col v-for="provider in sortedSilverPrices" :key="provider.source" cols="12" sm="2" md="4" lg="2">
              <SilverPriceWidget :name="provider.name" :prices="provider.prices" :loading="provider.loading" :error="provider.error" :min-price="minSilverPrice995" :max-price="maxSilverPrice995" :source-updated-at="provider.sourceUpdatedAt" />
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" sm="2" dir="ltr">
          <!-- <iframe src="https://goldbroker.com/widget/live-price/XAG?currency=USD" width="10%" height="100" style="border: 0; overflow: hidden;"></iframe> -->
          <iframe id="kitco" src="https://goldbroker.com/widget/live-price/XAG?currency=USD" width="100%" height="100" style="border: 0; overflow: hidden;"></iframe>
        </v-col>

      </v-row>
      <!-- <v-row dense>
        <v-col cols="12" sm="2" md="4" lg="2">
          <SilverPriceWidget name="نصیر" :prices="nasirPrices" :loading="nasirLoading" :error="nasirError" />
        </v-col>

        <v-col cols="12" sm="2" md="4" lg="2">
          <SilverPriceWidget name="خانه نقره" :prices="khaneNoghrePrices" :loading="khaneNoghreLoading" :error="khaneNoghreError" />
        </v-col>
      </v-row> -->

      <!-- <v-row dense>
        <v-col v-for="provider in silverPrices" :key="provider.source" cols="12" sm="2" md="4" lg="2">
          <SilverPriceWidget :name="provider.name" :prices="provider.prices" :loading="provider.loading" :error="provider.error" />
        </v-col>
      </v-row> -->

      <!-- <v-layout column style="height: 90vh">
      <v-flex sm style="overflow: auto"> -->
      <br>

      <v-btn class="mb-2" color="primary" large @click="printBank">
        <v-icon right>mdi-printer</v-icon>
        چاپ فرم حواله بین بانکی ملت
      </v-btn>
      <v-btn class="mr-3 mb-2" color="info" large @click="printBankInterval">
        <v-icon right>mdi-printer</v-icon>
        چاپ فرم حواله داخلی ملت
      </v-btn>
      <br>
      <MyTable :loading="loading" :headers="headers" :data="data" />
      <!-- </v-flex>
    </v-layout> -->
    </div>
    <div v-for="item in menus.items" :key="item.route" v-show="false">
      <span v-if="!item.subs">
      <v-btn v-shortkey="item.persiankey" @shortkey="actionkey(item.persiankey, item.route)"></v-btn>
    </span>
      <span v-if="item.subs">
      <v-btn v-for="sub in item.subs" :key="sub.title" link v-shortkey="sub.persiankey" @shortkey="actionkey(sub.persiankey, sub.route)" >
      </v-btn>
    </span>
    </div>
  </div>

</div>
</template>

<script>
// @ is an alias to /src
import myAxios from "../../functions/myAxios"
import homeMixin from "../../mixins/Home"
import MyTable from "../list/Table.vue"
import SilverPriceWidget from "../../components/dashboard/SilverPriceWidget.vue"
let myInterval;
// let res = await myAxios({method: "get", url: `/api/reports?q=${days}`});
export default {
  name: "MyDashboard",
  mixins: [homeMixin],
  methods: {
    async retrieveOunce() {
      try {
        //
        let myHeaders = new Headers();
        myHeaders.append("x-access-token", "goldapi-luv5asm27x2xxa-io");
        myHeaders.append("Content-Type", "application/json");

        let requestOptions = {
          method: "GET",
          headers: myHeaders,
          redirect: "follow"
        };

        fetch("https://www.goldapi.io/api/XAG/USD", requestOptions)
          .then(response => response.text())
          .then(result => {
            // console.log(result);
            this.ounce = JSON.parse(result)
          })
          // .then(result => console.log(JSON.parse(result).price))
          .catch(error => console.log("error", error));

        // console.log(res);
      } catch (e) {
        console.error(e)
      }
    },
    async retrieveData() {
      try {
        //
        let res = await myAxios({
          method: "GET",
          url: `/api/reports/last`,
          // params: query
        });
        // console.log(res);
        if (res && res.data) {
          this.data = res.data
          this.data.forEach((row) => {
            // console.log(res.data);
            if (['فروش'].includes(row.type)) {
              row.printInvoice = true
              row.first_item?.lending_value ? row.printLabel = false : row.printLabel = true
            } else if (['پرداخت کالا'].includes(row.type)) {
              row.printLabel = true;
            }
          })
        }
      } catch (e) {
        console.error(e)
      } finally {
        this.loading = false
      }
    },
    async retrieveSilverPrices() {
      if (this.silverPrices.length) {
        this.silverPrices = this.silverPrices.map(provider => ({
          ...provider,
          loading: true,
          error: null,
        }))
      }

      try {
        const res = await myAxios({
          method: "GET",
          url: "/api/silver-prices",
        })

        const providers = res && res.data

        if (!Array.isArray(providers)) {
          throw new Error("اطلاعات قیمت نقره نامعتبر است")
        }

        this.silverPrices = providers.map(provider => ({
          ...provider,
          loading: false,
          error: provider.status === "error" ?
            provider.lastError || "دریافت قیمت با خطا مواجه شده است" : null,
        }))

      } catch (e) {
        console.error("Silver prices:", e)

        this.silverPrices = this.silverPrices.map(provider => ({
          ...provider,
          loading: false,
          error: e.message || "دریافت قیمت نقره با خطا مواجه شد",
        }))
      }
    },
    printBank() {
      this.$router.push({
        name: 'bankPrint'
      })
    },
    printBankInterval() {
      this.$router.push({
        name: 'bankPrintInternal'
      })
    }
  },
  created() {
    this.headers = this.$store.getters.pageInfo.headers
    this.menus = JSON.parse(sessionStorage.getItem('menus'))

    this.retrieveData()
    this.retrieveSilverPrices()

    myInterval = setInterval(() => {
      refreshSilverOunce()
      this.retrieveSilverPrices()
    }, 60000)
  },
  data: () => ({
    route: '',
    titles: [],
    rows: [],
    file: null,
    selectedFile: null,
    data: [],
    loading: true,
    menus: null,
    //
    silverPrices: [],
  }),
  components: {
    MyTable,
    SilverPriceWidget,
  },
  computed: {
    minSilverPrice995() {
      const prices = this.silverPrices
        .map(provider => Number(provider.prices && provider.prices["995"]))
        .filter(price => Number.isFinite(price))

      if (!prices.length) {
        return null
      }

      return Math.min(...prices)
    },
    maxSilverPrice995() {
      const prices = this.silverPrices
        .map(provider => Number(provider.prices && provider.prices["995"]))
        .filter(price => Number.isFinite(price))

      if (!prices.length) {
        return null
      }

      return Math.max(...prices)
    },
    sortedSilverPrices() {
      return [...this.silverPrices].sort((a, b) => {
        const priceA = Number(a.prices && a.prices["995"])
        const priceB = Number(b.prices && b.prices["995"])

        const validA = Number.isFinite(priceA)
        const validB = Number.isFinite(priceB)

        // کارت‌های فاقد قیمت معتبر در انتها قرار بگیرند
        if (!validA && !validB) return 0
        if (!validA) return 1
        if (!validB) return -1

        // از کمترین قیمت به بیشترین قیمت
        return priceA - priceB
      })
    },
  },
  destroyed() {
    clearInterval(myInterval)
  },
}

function refreshSilverOunce() {
  document.getElementById("kitco").src += ""
}
</script>
